export default __webpack_public_path__ + "locales/uk-UA/CreateEditRoomDialog.json?hash=cc9e45851e80d7abe8893ee83df6f840";